<template>
  <div id="app">
    <div id="pad-w">
        <van-swipe :autoplay="5000" class="hntjlistbj" >
          <van-swipe-item v-for="(item, index) in info.picurl" :key="index">
            <div class="hntj-img"><img v-lazy="item.url"  /></div>
            <div class="h-6"></div>
            <van-button type="primary" size="mini" color="#e5a6ab" class=" mini-rz">{{info.rzzttext}}</van-button>
          </van-swipe-item>
        </van-swipe>
        <div class="hntj-botm">
          <van-button type="default" size="mini" class="mini-but-color mini-but-color-border">{{info.ncnicknamenc}}</van-button>
          <van-button type="primary" size="mini" color="#f5f5f5" class="mini-but-color" >{{info.birthday}}岁</van-button>
          <van-button type="primary" size="mini" color="#f5f5f5" class="mini-but-color">{{info.xlname}}</van-button>
          <van-button type="primary" size="mini" color="#f5f5f5" class="mini-but-color">{{info.sgname}}cm</van-button>
        </div>
    </div>
    <div class="bj-f7f7f7 h-15 cl"></div>
    <div id="pad-w" class="bj-fff">
      <van-cell title="个人风采" icon="../../static/image/ax.png" class="icon-ax" title-class="icon-title" :border="false"> </van-cell>
      <van-uploader
        class="mt-3"
        multiple
        v-model="info.picurl"
        :max-count="6"
        :deletable="false"
        :show-upload="false"
        >
      </van-uploader>
    </div>
    <div class="bj-f7f7f7 h-15 cl"></div>
    <div id="pad-w" class="bj-fff">
      <van-cell title="个人资料" icon="../../static/image/ax.png" class="icon-ax" title-class="icon-title" :border="false"> </van-cell>
      <van-row gutter="10">
        <van-col span="12" class="row-span">性别：{{info.sextext}} </van-col>
        <van-col span="12" class="row-span">年龄：{{info.birthday}}岁</van-col>
        <van-col span="12" class="row-span">身高：{{info.sgname}}cm</van-col>
        <van-col span="12" class="row-span">学历：{{info.xlname}}</van-col>
        <van-col span="12" class="row-span">籍贯：{{info.xzaddress}}</van-col>
        <van-col span="12" class="row-span">现居地：{{info.xjdaddress}}</van-col>
        <van-col span="12" class="row-span">职业：{{info.zyname}}</van-col>
        <van-col span="12" class="row-span">年收入：{{info.nsr}}</van-col>
        <van-col span="12" class="row-span">住房情况：{{info.zfqk}}</van-col>
        <van-col span="12" class="row-span">车辆情况：{{info.clqk}}</van-col>
      </van-row>
    </div>

    <div class="bj-f7f7f7 h-15 cl"></div>
    <div id="pad-w" class="bj-fff">
      <van-cell title="择偶要求" icon="../../static/image/ax.png" class="icon-ax" title-class="icon-title" :border="false"> </van-cell>
      <van-row gutter="10">
        <van-col span="12" class="row-span">年龄：{{info.zonlname}}岁</van-col>
        <van-col span="12" class="row-span">身高：{{info.sgnames}}cm</van-col>
        <van-col span="12" class="row-span">学历：{{info.zoxlname}}</van-col>
        <van-col span="12" class="row-span">婚姻状况：{{info.hyzktext}}</van-col>
        <van-col span="12" class="row-span">年收入：{{info.zosrname}}万元</van-col>
      </van-row>
    </div>
    <div class="bj-f7f7f7 bj-g">
      <van-button color="linear-gradient(to left, #fc597e, #ff5c60)" icon="./../static/image/ax2.png" round class="lx-but" @click="lxt(info.id,1)">
        我想联系Ta
      </van-button>

      <van-button color="linear-gradient(to left, #fc597e, #ff5c60)" icon="./../static/image/ax2.png" round class="lx-but" @click="lxt(info.id,2)">
        我想约Ta到店相亲
      </van-button>
    </div>
    <div class="bj-f7f7f7 bj-g">
      <div style="text-align: center;width: 80%;line-height: 22px;color: #999999;font-size: 15px;">{{info.tian}}</div>
    </div>


  </div>
</template>
<script>
export default {
  data () {
    return {
      info:[],
      id:'',
      picurllist:''

    }
  },
  created:function () {
    this.$emit('footer', false);
  },
  components: {
  },

  mounted () {
    this.id = this.$route.query.id;
    this.recordapi();
  },
  	methods: {
      lxt(id,type){

        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Index/yuehuiorder",{'yhid':this.id,'userid':userid,'type':type}).then(res => {
          console.log(res);
          // if(res.data)
          this.$toast(res.msg);
          // that.info = res.info;
        });
      },

      recordapi(){
          var that = this;
          var userid = that.$cookieStore.getCookie('userid');
          that.$api.post("/Index/usercont",{'id':this.id}).then(res => {
            console.log(res);
            that.info = res.info;
          });
      },

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Usercont.vue